import * as React from 'react';
import PropTypes from 'prop-types';
import { Modal } from 'react-bootstrap-5';
import Details from './details';

import { Button } from 'components/ui/button';

export default function DeleteModal({ requirement, shown, onClose, onDelete }) {
  const handleDelete = () => {
    onDelete(requirement);
    onClose();
  };

  return (
    <Modal centered show={shown} size="lg" onHide={() => onClose()}>
      <Modal.Header closeButton>
        <Modal.Title> Delete Requirement </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="w-100 ph-0">
          <div className="mt-3">
            This action is permanent. Are you sure you want to delete this requirement?
          </div>
          <Details requirement={requirement} />
        </div>
      </Modal.Body>
      <Modal.Footer>
        <div className="d-flex justify-content-end w-100 gap-2">
          <Button label="Cancel" variant="ghost" onClick={() => onClose()} />
          <Button label="Delete" variant="destructive" onClick={() => handleDelete()} />
        </div>
      </Modal.Footer>
    </Modal>
  );
}

DeleteModal.propTypes = {
  requirement: PropTypes.object,
  shown: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onDelete: PropTypes.func.isRequired
};
